import React from "react";
import { BookOpenIcon, WrenchIcon, MapIcon, PrinterIcon, DownloadIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { volumes, bonuses } from "../data/content";
const extras = [{
  icon: MapIcon,
  title: "A Visual Clinical Navigation Framework",
  body: "A structured overview that helps you navigate the collection according to the task you need to organize."
}, {
  icon: PrinterIcon,
  title: "Practical Worksheets and Checklists",
  body: "Printable resources to organize patient information, nutrition discussions, documentation, and follow-up."
}, {
  icon: DownloadIcon,
  title: "Instant Digital Access",
  body: "Download the materials and keep them available within your existing professional workflow."
}];
export function Summary() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-294" data-mp="26a7b7xdex42v">
      <div className="mx-auto max-w-4xl" data-id="element-295" data-mp="26apbr673y4gl">
        <SectionHeading eyebrow="Everything you need" title="Organize your insulin resistance nutrition references" subtitle="With Insulin Resistance Nutrition Blueprint™, you'll receive:" data-id="element-296" data-mp="35lk5ezxwk542" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-297" data-mp="2wmox9ibasky4">
          <div className="rounded-2xl bg-cream p-5 sm:p-7" data-id="element-298" data-mp="31k8nlgl9so6f">
            <div className="flex items-center gap-3" data-id="element-299" data-mp="31kqfk10wgg8j">
              <BookOpenIcon className="h-6 w-6 text-gold-dark" aria-hidden="true" data-id="element-300" data-mp="3p9t7q2t5trha" />
              <h3 className="font-serif text-xl font-bold text-navy" data-id="element-301" data-mp="3tbefj9qu7fkm">The Complete Six-Volume Collection</h3>
            </div>
            <ul className="mt-4 space-y-2.5" data-id="element-302" data-mp="3fatxifsqxns6">
              {volumes.map(v => <li key={v.numeral} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-303" data-mp="3kagjbdmn4ccl">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-304" data-mp="23w6winy1qvnv" />
                  {v.title.replace("The ", "").replace("™", "")}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl bg-cream p-5 sm:p-7" data-id="element-305" data-mp="1ot6rzmel9oo0">
            <div className="flex items-center gap-3" data-id="element-306" data-mp="1krv1zfrsz1fa">
              <WrenchIcon className="h-6 w-6 text-gold-dark" aria-hidden="true" data-id="element-307" data-mp="1ku7s4g7psi3f" />
              <h3 className="font-serif text-xl font-bold text-navy" data-id="element-308" data-mp="1fzk2uf4vzjns">Five Specialized Professional Tools</h3>
            </div>
            <ul className="mt-4 space-y-2.5" data-id="element-309" data-mp="1b0h5zhz28jqw">
              {bonuses.map(b => <li key={b.number} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-310" data-mp="16149e5idzyb4">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-311" data-mp="112t3g5v7q7y6" />
                  {b.title.replace("The ", "")}
                </li>)}
            </ul>
          </div>
        </div>

        <ul className="mt-8 divide-y divide-cream-dark border-y border-cream-dark" data-id="element-312" data-mp="2rh3coqcz2kvb">
          {extras.map(({
          icon: Icon,
          title,
          body
        }) => <li key={title} className="flex gap-4 py-5" data-id="element-313" data-mp="2mi04wy5ly0jn">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy text-gold" data-id="element-314" data-mp="2u1hv2udcxop6">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-315" data-mp="2yz16lmio7ndf" />
              </span>
              <div data-id="element-316" data-mp="33q9hyo3k9it8">
                <h3 className="text-[17px] font-bold text-navy" data-id="element-317" data-mp="33ruc4clyqzqk">{title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-318" data-mp="38qdz8gcamhki">{body}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[14px] italic leading-relaxed text-muted" data-id="element-319" data-mp="2b3otbvegzktd">
          This is not intended to replace clinical training, official guidelines, individualized assessment, or professional
          judgment. It is a practical reference collection designed to help you organize the information and review processes
          that support your work.
        </p>

        <div className="mt-10" data-id="element-320" data-mp="9sy1lpwksry">
          <CTAButton label="Yes, I want the complete blueprint" note="One-Time Payment of $27 USD · Instant Download · 7-Day Money-Back Guarantee" data-id="element-321" data-mp="4bnw8hcjeq1i" />
        </div>
      </div>
    </section>;
}